import React, { useEffect, useState } from "react";
import Chart from 'react-apexcharts';

export const RadarchartPreview = (props) => {
    const [chartData, setChartData] = useState({
        series: [],
        options: {
            chart: {
                type: 'radar',
            },
            labels: {
                show: false,
            },
        },
    });

    useEffect(() => {
        setChartData(formatProps(props));
    }, [props]);

    const formatProps = (props) => {
        let series = [];

        const processSerie = (name, values, exist) => {
            if (exist === "Y") {
                series.push({
                    name: name,
                    data: values.split(',').map(item => {
                        const num = parseFloat(item.trim());
                        return isNaN(num) ? 0 : parseFloat(num.toFixed(2));
                    }),
                });
            }
        };

        processSerie(props.serieName1, props.serieValues1, props.serie1Exist);
        processSerie(props.serieName2, props.serieValues2, props.serie2Exist);
        processSerie(props.serieName3, props.serieValues3, props.serie3Exist);
        processSerie(props.serieName4, props.serieValues4, props.serie4Exist);
        processSerie(props.serieName5, props.serieValues5, props.serie5Exist);

        return {
            series: series,
            options: {
                legend: {
                    show: props.showLegend === "Y",
                    position: props.legendPosition ?? '',
                    horizontalAlign: 'center',
                },
                tooltip: {
                    enabled: false,
                },
                colors: props.seriesColor
                    .split(",")
                    .map(color => color.startsWith("#") ? color : `#${color}`),
                plotOptions: {
                    radar: {
                        polygons: {
                            fill: {
                                colors: ['#F8F8F8', '#FFFFFF'],
                            },
                            labels: {
                                show: false,
                            },
                        },
                    },
                },
                chart: {
                    background: props.colorBackground,
                    fontFamily: props.fontFamily,
                    foreColor: '#373d3f',
                    type: 'radar',
                },
                stroke: {
                    width: 1,
                },
                fill: {
                    opacity: 0.1,
                },
                markers: {
                    size: 0,
                },
                xaxis: {
                    categories: props.categories.split(',').map(item => item.trim()),
                },

            },
        };
    };

    return (
        <div style={{ width: "100%", height: "100vh" }}> {/* Ajuste del contenedor */}
            <Chart
                options={chartData?.options ?? []}
                series={chartData?.series ?? []}
                type={'radar'}
                width="100%"
                height="100%" /* Se adapta al 100% del contenedor */
            />
        </div>
    );
};
